import api from "./api";
import { getTabclixCode } from "../helpers/embed-code";

let code = getTabclixCode()

const URLS = {
    fetchCssURL: `/api/css/${code}`,
    fetchContentURL: `/api/data/${code}`,
    fetchAuthUrl: '/oauth/token',
    postFormsURL: '/api/submit-form',
}

export async function fetchCss(authToken) {

    return api.get(URLS.fetchCssURL, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'userID': code,
            'Authorization': `Bearer ${authToken}`,
        }
    })
}


export async function fetchContent(authToken) {

    return api.get(URLS.fetchContentURL, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'userID': code,
            'Authorization': `Bearer ${authToken}`,
        }
    })
}

export async function postForms(authToken, formData) {

    return api.post(URLS.postFormsURL, formData, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'userID': code,
            'Authorization': `Bearer ${authToken}`,
        }
    })
}

export async function fetchAuth() {


    // If no token or expired, request a new one
    const form_data = new FormData();
    form_data.append('grant_type', 'client_credentials');
    form_data.append('client_id', process.env.REACT_APP_CLIENT_ID);
    form_data.append('client_secret', process.env.REACT_APP_CLIENT_SECRET);
    form_data.append('scope', '');

    try {
        const response = await api.post(URLS.fetchAuthUrl, form_data, {
            headers: {
                'Access-Control-Allow-Origin': '*',
            },
        });

        return response.data.access_token;
    } catch (error) {
        console.error('Error fetching auth token:', error);
    }
}

